/**
 * THIS FILE AUTOMATICALLY GENERATED, DO NOT EDIT!
 */
/**
 * Maps the post type to the respective sub-path
 * @type {[{path: string, postType: string},{path: string, postType: string},{path: string, postType: string},{path: string, postType: string}]}
 */

//  Needed for sitemap and things like that, first locale is condisdered to be default locale
export const configuredLanguages = ["en", "de"];

// TODO on setup: post type path mapping extend with custom post types if necessary
// Language is only used to know which language it is, but never used!
// Path name is displayed in breadcrumbs
export const customPostTypesPathMapping = [
  { postType: "audios", path: "audio", language: "en" },
  { postType: "blog", path: "press", language: "en" },
  { postType: "catalog", path: "katalog", language: "en" },
  { postType: "culinary", path: "kulinarik", language: "en" },
  { postType: "events", path: "dates", language: "en" },
  { postType: "highlights", path: "highlights", language: "en" },
  { postType: "rooms", path: "zimmeruebersicht", language: "en" },
  { postType: "videos", path: "video", language: "en" },
  { postType: "audios", path: "audio", language: "de" },
  { postType: "blog", path: "journal", language: "de" },
  { postType: "catalog", path: "katalog", language: "de" },
  { postType: "culinary", path: "kulinarik", language: "de" },
  { postType: "events", path: "termine", language: "de" },
  { postType: "highlights", path: "highlights", language: "de" },
  { postType: "rooms", path: "zimmeruebersicht", language: "de" },
  { postType: "videos", path: "video", language: "de" },
];

export function getPostTypeForPath(path: string) {
  return customPostTypesPathMapping.filter((mapping) => {
    return mapping.path === path;
  });
}

/** get list with all unigue post types for static path generation **/
export const postTypes = [
  ...new Set(
    customPostTypesPathMapping.map((item) => {
      return item.postType;
    }),
  ),
];
